import { Field } from '@/catalog/types/field';
import { securityManager } from '@/common/services/SecurityManager';
import { ACCESS_GATED_FIELDS, AccessGatedFieldRule, SecurityActionType } from '@/product/constants/accessGatedFields';
import { CrosstabAxis } from '@/product/types/CrosstabAxis';

class AccessGatedFieldRepository {
  isSortAvailable = (sort: { field: string }): boolean => this.isGranted(this.sortFieldActions.get(sort.field));

  isFilterAvailable = (filter: { id: string }): boolean => this.isGranted(this.filterFieldActions.get(filter.id));

  isCatalogFieldAvailable = (field: Field): boolean => this.isGranted(this.catalogFieldActions.get(field.key));

  isCrosstabAxisAvailable = (axis: CrosstabAxis): boolean => this.isGranted(this.crosstabAxisActions.get(axis));

  private readonly rules = Object.values(ACCESS_GATED_FIELDS);

  private readonly sortFieldActions = this.buildActionMap((rule) => rule.sortFields);

  private readonly filterFieldActions = this.buildActionMap((rule) => rule.filterFieldIds);

  private readonly catalogFieldActions = this.buildActionMap((rule) => rule.catalogFieldKeys);

  private readonly crosstabAxisActions = this.buildActionMap((rule) => rule.crosstabAxes);

  private buildActionMap<T>(select: (rule: AccessGatedFieldRule) => T[]): Map<T, SecurityActionType> {
    return new Map(this.rules.flatMap((rule) => select(rule).map((id) => [id, rule.securityAction] as const)));
  }

  private isGranted(action: SecurityActionType | undefined): boolean {
    const isAlwaysAllowed = !action;

    return isAlwaysAllowed || Boolean(securityManager.isGranted(action));
  }
}

export const accessGatedFieldRepository = new AccessGatedFieldRepository();
